// extracted by mini-css-extract-plugin
export default {"wrapper":"FollowUps_wrapper__jvrQ6","label":"FollowUps_label__HAWn4","chips":"FollowUps_chips__20bVj","chip":"FollowUps_chip__z+V0+"};